import { type Dictionary } from '@ngrx/entity';

import {
  type CanvasElement,
  type CanvasElementId,
  type CanvasNamespaceId,
} from '@blaze-runtime/engine-domain';

import { isElementType } from '../../canvas-elements/element-model/element-type-guards';

/** Returns the namespace of the elements presented on the overlay if it's present */
export function getForegroundNs(
  entities: Dictionary<CanvasElement>,
  overlayIds: CanvasElementId[],
): CanvasNamespaceId | undefined {
  const overlay = entities[overlayIds[0]];
  return isElementType(overlay, '_overlay') // if overlay (ie dialog)
    ? overlay.slots.main?.hosting?.ns
    : undefined;
}
